/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetProductCategoties,
    GetProductsByFactoryIDProductcatogeryID,
    GetPriceUpdateDetails,
    UpdateDailyPriceUpdateDetails,
    GetAllMarketPriceDetails,
    GetProductDetails,
    RealizedPriceApproveDetails,
    RealizedPriceRejectDetails,
    SndPPRejectDetails,
    SndPPApproveDetails
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductcatogeryID', 'factoryID=' + parseInt(factoryID) + '&productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetPriceUpdateDetails(model) {
    const response = await CommonPost('/api/ProductPrice/GetPriceUpdateDetails', null, model);
    return response.data;
}

async function UpdateDailyPriceUpdateDetails(model) {
    const response = await CommonPost('/api/ProductPrice/UpdateDailyPriceUpdateDetails', null, model);
    return response;
}

async function GetAllMarketPriceDetails(model) {
    const response = await CommonPost('/api/ProductMarketPriceWeb/GetAllMarketPriceDetails', null, model);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function RealizedPriceApproveDetails(model) {
    const response = await CommonPost('/api/ProductPrice/RealizedPriceApproveDetails', null, model);
    return response;
}

async function RealizedPriceRejectDetails(model) {
    const response = await CommonPost('/api/ProductPrice/RealizedPriceRejectDetails', null, model);
    return response;
}

async function SndPPRejectDetails(model) {
    const response = await CommonPost('/api/ProductPrice/SndPPRejectDetails', null, model);
    return response;
}

async function SndPPApproveDetails(model) {
    const response = await CommonPost('/api/ProductPrice/SndPPApproveDetails', null, model);
    return response;
}